import LocomotiveScroll from 'locomotive-scroll';

const scroll = new LocomotiveScroll({
    wrapper: window,
    content: document.documentElement,
    lerp: 0.1,
    duration: .5,
    orientation: 'vertical',
    gestureOrientation: 'vertical',
    smoothWheel: true,
    smoothTouch: false,
    wheelMultiplier: 1,
    touchMultiplier: 2,
    normalizeWheel: true,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
})


export default function scrollTo(params) {
    const {target, options} = params;
    scroll.scrollTo(target, options);
}

scroll.scrollTo('top', {
    lerp: 0,
    duration: 0
});

export function scrollStart() {
    requestAnimationFrame(() => {
        scroll.start();
    });
}

export function scrollStop() {
    requestAnimationFrame(() => {
        scroll.stop();
    });
}

export function scrollDestroy() {
    scroll.destroy();
}
